export default "__VITE_ASSET__774374b0__"